// import {
//   FETCH_BRANCH_FAILURE,
//   FETCH_BRANCH_REQUEST,
//   FETCH_BRANCH_SUCCESS,
// } from "./branchActionTypes";

// export const fetchBranchRequest = () => ({
//   type: FETCH_BRANCH_REQUEST,
// });

// export const fetchBranchSuccess = (data, dataType) => ({
//   type: FETCH_BRANCH_SUCCESS,
//   payload: { data, type: dataType },
// });

// export const fetchBranchFailure = (error) => ({
//   type: FETCH_BRANCH_FAILURE,
//   payload: error,
// });
import {
  FETCH_BRANCH_REQUEST,
  FETCH_BRANCH_SUCCESS,
  FETCH_BRANCH_FAILURE,
  CREATE_BRANCH_REQUEST,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAILURE,
  UPDATE_BRANCH_REQUEST,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAILURE,
  DELETE_BRANCH_REQUEST,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAILURE,
} from "./branchActionTypes";

// FETCH
export const fetchBranchRequest = () => ({
  type: FETCH_BRANCH_REQUEST,
});

export const fetchBranchSuccess = (data, dataType) => ({
  type: FETCH_BRANCH_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchBranchFailure = (error) => ({
  type: FETCH_BRANCH_FAILURE,
  payload: error,
});

// CREATE
export const createBranchRequest = () => ({
  type: CREATE_BRANCH_REQUEST,
});

export const createBranchSuccess = (data, dataType) => ({
  type: CREATE_BRANCH_SUCCESS,
  payload: { data, type: dataType },
});

export const createBranchFailure = (error) => ({
  type: CREATE_BRANCH_FAILURE,
  payload: error,
});

// UPDATE
export const updateBranchRequest = () => ({
  type: UPDATE_BRANCH_REQUEST,
});

export const updateBranchSuccess = (data, dataType) => ({
  type: UPDATE_BRANCH_SUCCESS,
  payload: { data, type: dataType },
});

export const updateBranchFailure = (error) => ({
  type: UPDATE_BRANCH_FAILURE,
  payload: error,
});

// DELETE
export const deleteBranchRequest = () => ({
  type: DELETE_BRANCH_REQUEST,
});

export const deleteBranchSuccess = (data, dataType) => ({
  type: DELETE_BRANCH_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteBranchFailure = (error) => ({
  type: DELETE_BRANCH_FAILURE,
  payload: error,
});
